import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3816deb6033d4b560619a5273eea7dd3b from "./generated-386f3677-eec6-4cb3-97ea-74a194d3297b.json";

import a166406b52d494bfcf93b50474105af24b from "./generated-e34f798e-e6aa-4db7-9dcb-e90692b1175a.json";

import a2c9bc08195e268aa8450f9b4ad8b6fffb from "./generated-5c7598a5-3eed-4cdf-b93f-e4feefa7701b.json";

import aa1805c2d36410a270f5da8abce388655b from "./generated-9ff9a05e-f7c0-43f1-9ce6-17bb29c48b63.json";

import a32ca845315dca2bbffdbec1c9decc1acb from "./generated-680861f7-96f4-49db-9b40-0c4f5dd90660.json";

import a96240cdc066875f9ee1aafd6118f6655b from "./generated-2dff2b41-c1da-4cf1-8ee4-48c3788bcda9.json";

import ad3a592f7802709ee5474046f0bfec558b from "./generated-ba9ec09b-1891-4d46-96c7-86e3e0800f17.json";

import aa73eba506dd7bf5d372db9310193d98bb from "./generated-50ecd848-e2ac-4c23-b680-329e15f58e6d.json";

import aad65dc6a1704757c33678d7e08083fe2b from "./generated-2f2d918e-a99f-4e73-8804-a788442ad925.json";

import a873a34b0f06810fff6d68ff19554cc75b from "./generated-b404e32a-54ba-4916-b556-ef209823b566.json";

import a257f05ccb76729ad4f00d0e030275cc6b from "./generated-6c8a583a-38af-4332-aed9-0987fccd1552.json";

import a0b634463522311664a1e74ead790cb81b from "./generated-8278ed75-5702-4fb9-b084-e976e796a015.json";

import a91cf5ce88ba61dcaf246383bfa4e624bb from "./generated-5132174d-09b9-4047-9e0c-54e3340e6a68.json";

import a4ee1d20241ae303f77ba1e63729e0c01b from "./generated-b9a8aa14-0d75-42f6-b486-f128aea17ddc.json";

import a401ac75c5b445fb23ceacabf9b26adbcb from "./generated-5c476153-b293-4ceb-8ca2-b2af9003e7bd.json";

import a19ad0533b6a3303fea1ecdf2d5a29d46b from "./generated-e7e519ea-acc8-47ad-b3c5-22a8b5cdeea6.json";

import a1b5069b71f9d1f00565b1e4e441c5352b from "./generated-31eeb01a-9efd-4cb5-b029-0d7191ac1293.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3816deb6033d4b560619a5273eea7dd3b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a166406b52d494bfcf93b50474105af24b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a2c9bc08195e268aa8450f9b4ad8b6fffb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aa1805c2d36410a270f5da8abce388655b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a32ca845315dca2bbffdbec1c9decc1acb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a96240cdc066875f9ee1aafd6118f6655b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad3a592f7802709ee5474046f0bfec558b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aa73eba506dd7bf5d372db9310193d98bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aad65dc6a1704757c33678d7e08083fe2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a873a34b0f06810fff6d68ff19554cc75b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a257f05ccb76729ad4f00d0e030275cc6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a0b634463522311664a1e74ead790cb81b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aad65dc6a1704757c33678d7e08083fe2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a91cf5ce88ba61dcaf246383bfa4e624bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4ee1d20241ae303f77ba1e63729e0c01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aad65dc6a1704757c33678d7e08083fe2b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a401ac75c5b445fb23ceacabf9b26adbcb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a19ad0533b6a3303fea1ecdf2d5a29d46b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a1b5069b71f9d1f00565b1e4e441c5352b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a401ac75c5b445fb23ceacabf9b26adbcb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */